export default __webpack_public_path__ + "static/media/Get Support Image.eabdcadd.png";